<template>
  <div style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundBanner})` }" class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="10">
          <CCardGroup>
            <CCard class="p-4 box-shadow">
              <CCardBody>
                <div class="text-center">
                  <img style="width: 100px" src="../assets/img/Logo.png" />
                  <h4 class="mt-2">Hi, Welcome back to Login !</h4>
                  <p class="text-muted">Sign In to your account</p>
                </div>

                <CForm>
                  <CInput placeholder="Email" autocomplete="email" v-model="email">
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="12" class="text-left">
                      <CButton color="primary" class="px-4" @click="InsertLogin" block>Login</CButton>

                      
                    </CCol>
                      <div v-if="this.ErrorMessage===true" class="ml-4 mr-4">
                          <CAlert show color="danger">
                            <strong class="text-danger mr-2">X ERROR ! </strong>
                          </CAlert>
                        </div>
                        <div v-if="this.SuccessMessage===true" class="ml-4 mr-4">
                          <CAlert show color="success"
                            >You have successfully save the data</CAlert
                          >
                        </div>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <h2>Pickiddo Login</h2>
                <p>Pickiddo is a platform to manage online tuition by providing on-demand tuition services.</p>
               <img style="max-width:100%" src="../assets/img/imgVector.png" />
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>


<script>
import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundBanner from "../assets/img/bgLogin.png";

import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProClass",
  data() {
    return {
      backgroundBanner,
     email,
     password,

        ErrorMessage: true,
      SuccessMessage: true,
    };
  },
  created() {
    AOS.init();
  },
  methods: {
    InsertLogin() {
      const formData = new FormData();

      formData.append("Email", this.email);
      formData.append("Password", this.password);

      return this.$API
        .post(this.$LoginTeacher, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.userId = response.data;
              this.ErrorMessage = true;
          }
          else
          {
              this.$dialog
              .alert("Only teacher are allowed to login")
              .then(function (dialog) {
                console.log("Closed");
              });

          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
  },
};
</script>


